import * as React from "react"
const TreePilotMentorIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 141.73 141.73"
        {...props}
    >
        <title>{"Mesa de trabajo 3"}</title>
        <g id="Capa_2" data-name="Capa 2">
            <rect
                width={81.44}
                height={4.33}
                x={30.97}
                y={136.28}
                className="cls-1"
                rx={1.62}
            />
            <circle cx={71.93} cy={81.54} r={4.44} className="cls-1" />
            <path
                d="M108.18 126c-9.31-.85-13.19-5.72-13.56-6.54-8.49-18.41-3.1-38.39-2.56-40.25 0-.1.06-.19.1-.29.55-1.37 5-11.55 14.79-13.89a3 3 0 0 0 2.26-3.5 2.94 2.94 0 0 0-4-2.09l-5 2.06a2.91 2.91 0 0 1-4-2.34c-.13-1.56-1.12-3-4.19-3 0 0-.63-.91-4.5 4.25a3.24 3.24 0 0 1-.48.5c-2.1 1.73-15.82 12-30 .13a3 3 0 0 1-.65-.78c-.8-1.39-3.58-5.62-6.65-3.75a2.81 2.81 0 0 0-1 1 4.74 4.74 0 0 0-.61 1.49A3 3 0 0 1 44 61.1a36.38 36.38 0 0 0-6.92-2.37 2.93 2.93 0 0 0-3.56 2.67v.55A2.91 2.91 0 0 0 35.8 65c2.15.46 5.54 1.75 9.56 5.33 0 0 6.49 4.24 8.09 16.37 0 0 3.2 24.46-4.4 33.14a3.34 3.34 0 0 0-.43.63c-.51.94-2.89 4-13 5.54a4.76 4.76 0 0 0-3.49 2.06 2.93 2.93 0 0 0 2.48 4.52h75.1a2.92 2.92 0 0 0 2.81-3.81c-.52-1.3-1.67-2.51-4.34-2.78Zm-40.1-1.85a1.63 1.63 0 1 1-3.25 0V110a1.63 1.63 0 1 1 3.25 0Zm7.54-16.59a1.8 1.8 0 0 1-3.59 0V96.25a1.8 1.8 0 0 1 3.59 0Zm3.75 18a1.85 1.85 0 0 1-3.7 0v-10.25a1.85 1.85 0 0 1 3.7 0Zm-7.44-36.23A8.09 8.09 0 1 1 80 81.24a8.09 8.09 0 0 1-8.07 8.09Z"
                className="cls-1"
            />
            <path
                d="M35.71 66.56a5.3 5.3 0 0 1-4.09-3.83v-.08s-11.91-1.79-18.69 7.23c0 0 14.11 12.61 27.75-.47-.02 0-.28-1.84-4.97-2.85ZM29.09 58.69s1-19.23-23.37-16.41c0 0 1.65 21.49 23.37 16.41ZM39.25 36.4s-3.26-3.13-11-3c0 0-4.89 13.73 13.55 21.56.02.04 6.47-11.47-2.55-18.56ZM70.68 47.86S74 17.35 44 21c0 0-.74 24.67 26.68 26.86ZM33.89 26.15S27 13.36 15.64 22.49c0 0 6.21 10.81 18.25 3.66Z"
                className="cls-1"
            />
            <path
                d="M41.13 20S45.26 4.05 22.88 2.17c0 0-1.03 20.13 18.25 17.83ZM111.07 62.65v.08a5.3 5.3 0 0 1-4.07 3.83c-4.69 1-4.94 2.85-4.94 2.85 13.63 13.08 27.74.47 27.74.47-6.8-9.02-18.73-7.23-18.73-7.23ZM112.64 58.69C134.37 63.77 136 42.28 136 42.28c-24.34-2.82-23.36 16.41-23.36 16.41ZM99.92 55c18.43-7.83 13.54-21.56 13.54-21.56-7.71-.13-11 3-11 3-9 7.05-2.54 18.56-2.54 18.56ZM100.28 21c-30-3.64-26.72 26.87-26.72 26.87C101 45.67 100.28 21 100.28 21ZM126.09 22.49c-11.38-9.13-18.24 3.66-18.24 3.66 12.03 7.15 18.24-3.66 18.24-3.66Z"
                className="cls-1"
            />
            <path
                d="M118.85 2.17C96.47 4.05 100.61 20 100.61 20c19.27 2.3 18.24-17.83 18.24-17.83ZM70.56 20.46c.19-25.9-22-18.29-22-18.29 2.63 20.03 22 18.29 22 18.29ZM95.46 2.17s-22.19-7.61-22 18.29c-.01 0 19.37 1.74 22-18.29Z"
                className="cls-1"
            />
        </g>
    </svg>
)
export default TreePilotMentorIcon
